import React from 'react';
import ServicePage from '../../components/PublicSite/ServicePage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Battery, Unlocking, Brakes, AC & Oil at Your Location | Bas Recovery',
    description: 'Jump start from AED 130, car unlock AED 250, battery change AED 300, brakes, AC and oil done where the car is parked. Call 050 505 2213.',
    component: (
      <HeadLessLayout>
        <ServicePage service="carservices" />
      </HeadLessLayout>
    ),
  };
}

export default action;
